import React from 'react';
import { Box } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

const RatingInput: React.FC<{ value: number; onChange: (v: number) => void }> = ({ value, onChange }) => (
  <Box sx={{ display: 'flex', gap: 0.5 }}>
    {[1, 2, 3, 4, 5].map((n) => (
      <StarIcon
        key={n}
        onClick={() => onChange(value === n ? 0 : n)}
        sx={{ fontSize: 34, cursor: 'pointer', color: n <= value ? '#FFC107' : '#BBBFC7' }}
      />
    ))}
  </Box>
);

export default RatingInput;
